"use client";

import {PhotoProvider, PhotoView} from "react-photo-view";
import React from "react";
import styles from "../PhotoViewer/style.module.css";
import Image from "next/image";
import {File } from '../../types/fileDetails'

export const PhotoViewer = ({
  files
}: {
  files: Array<File>
}) => {

  return (
    <PhotoProvider>
      <div className={styles.imageWrapper}>
        {files.map((file, index) => (
          <PhotoView key={index} src={`https://lh3.googleusercontent.com/d/${file.id}`}>
            <figure style={{"--width": file.size?.width, "--height": file.size?.height} as React.CSSProperties}>
              <Image
                unoptimized
                loading={index < 2 ? 'eager' : 'lazy'}
                placeholder='blur'
                className={styles.image}
                width={file.size?.width}
                height={file.size?.height}
                src={`https://lh3.googleusercontent.com/d/${file.id}=s450`}
                blurDataURL={file.rgbDataURL}
                alt={file.name ?? ''}
              />
            </figure>
          </PhotoView>
          ))}
      </div>
    </PhotoProvider>
)
}
